import { Space, Table, Tag } from 'antd';
import React, { useEffect } from 'react'
import { useState } from 'react';
import ProgrammeService from '../../../api/programme.service';
import commonUtility from '../../../utility/Utils';
import { GREEN_TAG, RED_TAG } from '../../../utility/Constants';

const ProgrammeList = () => {
  // const [visible, setVisible] = useState(false);
  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);

  const [programmeList, setProgrammeList] = useState([]);

  /*
  const [paymentModeData, setPaymentModeData] = useState({
      id: 0,
      payment_mode: '',
      account_id: '',
      mode: EDIT_MODE
  });

  const showDrawer = (rowdata) => {
  
  setPaymentModeData({
      id: rowdata.id,
      payment_mode: rowdata.payment_mode,
      account_id: rowdata.account_id,
      mode: EDIT_MODE
  })

    setVisible(true);

  };


  const onClose = () => {
    setVisible(false);
  };

*/
  


  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'programme_name',
      key: 'programme_name',
      sorter: (a, b) => a.programme_name.localeCompare(b.programme_name),
      
    },
    {
        title: 'Short Code',
        dataIndex: 'short_code_text',
        key: 'short_code_text',
        sorter: (a, b) => a.short_code_text.localeCompare(b.short_code_text), 
      },
      {
        title: 'Age Limit',
        dataIndex: 'is_age_limit',
        key: 'is_age_limit',
       

        
      },
      {
        title: 'Min Age',
        dataIndex: 'min_age',
        key: 'min_age',
        align:'right'
        
      },
      {
        title: 'Max Age',
        dataIndex: 'max_age',
        key: 'max_age',
        align:'right'
        
      },
      {
        title: 'Active',
        dataIndex: 'is_active',
        key: 'is_active',
        sorter: (a, b) => a.is_active.localeCompare(b.is_active), 
        render: (selectedObj,record) => (
          <Space size="middle">
            {
              record.is_active == "Y" ? <><Tag color={GREEN_TAG}>Active</Tag></> : <><Tag color={RED_TAG}>Not Active</Tag></>
            }
          </Space>
        )
        
      },
    /*
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
    */
  ];


  useEffect(() => {
      ProgrammeService.programmeList().then((res) => {
          // console.log(res.data.response_data);
          setProgrammeList(res.data.response_data);
      });
  }, [])

  return (
    <>
      <Table 
        columns={columns} 
        rowKey='programme_id' 
        dataSource={programmeList}
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size='small'
      />

      {
          /*
      
      <Drawer
          title="Edit Payment Mode"
          width="478px"
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}

        >
          <PaymentModeEntry data={paymentModeData}/>
        </Drawer>
       */ }

    </>
  );
}

export default ProgrammeList